import {
  FormControl,
  HStack,
  Icon,
  IconButton,
  Spinner,
  Stack,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useToast,
} from '@chakra-ui/react';
import React, { useContext, useState } from 'react';
import { FiTrash } from 'react-icons/all';
import { Button, Heading, ReactSelect, Table } from '~/components';
import { SelectItem } from '~/types';
import { useCompanyGroupsAsSelect } from '~/hooks';
import { FilterContext } from '~/contexts/FilterContext/FilterContext';
import api from '~/utils/api';
import { useWhitelist } from '~/hooks/useNonPayment';
import { queryClient } from '~/utils/react-query';

export const Whitelist: React.VFC = () => {
  const [id_grupoeconomico, setGroup] = useState<SelectItem | null>(null);
  const [isLoadingRequest, setIsLoadingRequest] = useState(false);
  const [isLoadingAddRequest, setIsLoadingAddRequest] = useState(false);

  const { groups } = useContext(FilterContext);
  const { data: groupsSelected, isLoading: isGroupsLoading } =
    useCompanyGroupsAsSelect({}, 9999, groups);
  const toast = useToast();

  const { data, isLoading, isError, isFetching } = useWhitelist();

  function handleGroup(e: SelectItem) {
    setGroup(e);
  }

  const removeFromWhitelist = (id: string) => {
    setIsLoadingRequest(true);
    api
      .delete(`/controle_inadimplencia/whitelist/${id}`)
      .then(res => {
        toast({
          title: 'Grupo removido',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        queryClient.invalidateQueries('whitelist');
      })
      .catch(e => {
        toast({
          title: e.response.data.message,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .finally(() => {
        setIsLoadingRequest(false);
      });
  };

  const addToWhitelist = () => {
    setIsLoadingAddRequest(true);
    api
      .post('/controle_inadimplencia/whitelist', {
        grupo: id_grupoeconomico?.value,
      })
      .then(res => {
        toast({
          title: 'Grupo adicionado',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        queryClient.invalidateQueries('whitelist');
        setGroup(null);
      })
      .catch(e => {
        toast({
          title: e.response.data.message,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .finally(() => {
        setIsLoadingAddRequest(false);
      });
  };

  return (
    <Stack gridGap={3}>
      <Heading fontSize="16px">
        Grupos de clientes que não recebem e-mails de cobrança
      </Heading>
      <HStack alignItems="end" w="400px">
        <FormControl>
          <ReactSelect
            name="id_grupoeconomico"
            isSearchable
            label="Grupo"
            placeholder="Selecione"
            options={groupsSelected}
            value={id_grupoeconomico}
            onChange={e => handleGroup(e as SelectItem)}
            defaultStyle
            isDisabled={isGroupsLoading}
          />
        </FormControl>
        <Button
          onClick={() => addToWhitelist()}
          isDisabled={!id_grupoeconomico || isLoadingAddRequest || isLoading}
        >
          Adicionar{' '}
          {isLoadingAddRequest && <Spinner style={{ marginLeft: '10px' }} />}
        </Button>
      </HStack>
      <Table type="secondary" w="650px">
        <Thead>
          <Tr>
            <Th>Grupos</Th>
            <Th>Ações</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data && data.length > 0 ? (
            data?.map(item => (
              <Tr>
                <Td w="90%">
                  <Text textOverflow="ellipsis">{item.nm_grupo}</Text>
                </Td>
                <Td>
                  <Text>
                    <Tooltip label="Deletar" placement="top">
                      <IconButton
                        isDisabled={isLoadingRequest}
                        w="25px"
                        fontSize="20px"
                        background="transparent"
                        aria-label="Remove item"
                        icon={<Icon as={FiTrash} />}
                        onClick={() => removeFromWhitelist(item.id)}
                      />
                    </Tooltip>
                  </Text>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td>Não há dados a serem apresentados</Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </Stack>
  );
};
